import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import {SvgIconTypeMap} from '@mui/material';
import {OverridableComponent} from '@mui/material/OverridableComponent';
import InventoryIcon from '@mui/icons-material/Inventory';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import DesignServicesIcon from '@mui/icons-material/DesignServices';

type RouteType = {
    name: string;
    path: string;
    icon?: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
}

export enum MyRoutes {
    CALENDAR = "/app/calendar",
    APPOINTMENT = "/app/appointment",
    DAILY_RECONCILIATION = "/app/daily-reconciliation",

    RECONCILIATION = "/app/reconciliation",
    REVIEWS = "/app/reviews",
    DOCTORS = "/app/doctors",
    INVOICE_FOR_PAYMENT = "/app/invoice-for-payment",


}

export const privateRoute = []


export const menuRoutes: RouteType[] = [

    {name: "Календарь", path: MyRoutes.CALENDAR, icon: PersonRoundedIcon},
    {name: "Записи", path: MyRoutes.APPOINTMENT, icon: InventoryIcon},
    {name: "Ежедневная сверка", path: MyRoutes.DAILY_RECONCILIATION, icon: FactCheckIcon},
    {name: "Сверка", path: MyRoutes.RECONCILIATION, icon: DesignServicesIcon},
    {name: "Отзывы", path: MyRoutes.REVIEWS, icon: ChatBubbleIcon},
    {name: "Врачи", path: MyRoutes.DOCTORS, icon: EngineeringRoundedIcon},
    // {name: "Счета на оплату", path: MyRoutes.INVOICE_FOR_PAYMENT, icon: DesignServicesIcon},
]

export const publicRoute = []